import { connect } from 'react-redux';
import Map from '../components/Map';
import {setMapBounds, getShopsAtPosition} from '../actions';

const mapStateToProps = (state) => {
  return {
    items: state.search.result,
    searchPosition: state.search.position,
    zoom: state.map.zoom,
    center: state.map.center,
    isDirty: state.map.dirty,
  };
};

const mapDispatchToProps = (dispatch) => ({
  mapBoundsSet: () => dispatch(setMapBounds(false)),
  onRecenter: newCenter => {
    dispatch(getShopsAtPosition(newCenter, false))
  }
});

const MapContainer = connect(mapStateToProps, mapDispatchToProps)(Map);

export default MapContainer;
